export enum BatchStatus {
	PENDING = 'PENDING',
	PROCESSING = 'PROCESSING',
	COMPLETED = 'COMPLETED',
	FAILED = 'FAILED'
}

export interface BatchItem {
	cpf: string;
	status: string;
	resultMessage?: string;
}

export interface Batch {
	id: string;
	name: string;
	status: BatchStatus;
	total: number;
	processed: number;
	success: number;
	fail: number;
	fileUrl?: string;
	createdAt: string;
}
